/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_SuccessInputs */

const en_metadata_merge_success = /** @type {(inputs: Metadata_Merge_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata merged successfully`)
};

const fr_metadata_merge_success = /** @type {(inputs: Metadata_Merge_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métadonnées fusionnées avec succès`)
};

const de_metadata_merge_success = /** @type {(inputs: Metadata_Merge_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten erfolgreich zusammengeführt`)
};

const it_metadata_merge_success = /** @type {(inputs: Metadata_Merge_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadati uniti con successo`)
};

const ru_metadata_merge_success = /** @type {(inputs: Metadata_Merge_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданные успешно объединены.`)
};

const es_metadata_merge_success = /** @type {(inputs: Metadata_Merge_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los metadatos se fusionaron correctamente.`)
};

const zh_cn2_metadata_merge_success = /** @type {(inputs: Metadata_Merge_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据合并成功`)
};

const ja_metadata_merge_success = /** @type {(inputs: Metadata_Merge_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータのマージに成功しました。`)
};

const hi_metadata_merge_success = /** @type {(inputs: Metadata_Merge_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा सफलतापूर्वक मर्ज हो गया`)
};

const pt_pt2_metadata_merge_success = /** @type {(inputs: Metadata_Merge_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados mesclados com sucesso`)
};

/**
* | output |
* | --- |
* | "Metadata merged successfully" |
*
* @param {Metadata_Merge_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_success = /** @type {((inputs?: Metadata_Merge_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_success(inputs)
	if (locale === "de") return de_metadata_merge_success(inputs)
	if (locale === "it") return it_metadata_merge_success(inputs)
	if (locale === "ru") return ru_metadata_merge_success(inputs)
	if (locale === "es") return es_metadata_merge_success(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_success(inputs)
	if (locale === "ja") return ja_metadata_merge_success(inputs)
	if (locale === "hi") return hi_metadata_merge_success(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_success(inputs)
	return en_metadata_merge_success(inputs)
});